/**
 * Extract SKU patterns from text
 * Supports: KX codes, hyphen-numeric codes (861-..., 4810940008-...)
 */
export const extractSKUs = (text: string): string[] => {
  // Match KX codes, 861-XXX-XXX patterns, and XXXXXXXXXX-XXXX patterns
  const patterns = [
    /\b(KX\d{5,})\b/gi,              // KX12345...
    /\b(\d{3}-\d{8}-\d{4})\b/g,      // 861-20040001-1500
    /\b(\d{3}-[A-Z0-9]{8}-\d{4})\b/gi, // 100-A3000101-2200 (with alphanumeric)
    /\b(\d{10}-\d{4})\b/g            // 4810940008-0000
  ];
  
  const allMatches: string[] = [];
  
  patterns.forEach(pattern => {
    const matches = text.match(pattern) || [];
    allMatches.push(...matches);
  });
  
  return [...new Set(allMatches.map(sku => sku.toUpperCase()))];
};
